import { useAppSelector } from '@/hooks/useAppSelector';

import { messagesSelector } from '../services/selectors';

export const useMessages = () => useAppSelector(messagesSelector);
